var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4037 12.5961C9.28247 11.4749 8.43722 10.2194 7.87564 8.94582C7.75681 8.67653 7.82677 8.36123 8.03472 8.15327L8.8196 7.36936C9.46264 6.72632 9.46264 5.81686 8.90106 5.25527L7.77597 4.13019C7.02752 3.38173 5.81427 3.38173 5.06581 4.13019L4.44097 4.75502C3.73085 5.46515 3.43472 6.48961 3.62639 7.50544C4.09981 10.0096 5.55456 12.7514 7.90152 15.0983C10.2485 17.4453 12.9903 18.9 15.4944 19.3734C16.5102 19.5651 17.5347 19.269 18.2448 18.5589L18.8687 17.935C19.6171 17.1865 19.6171 15.9733 18.8687 15.2248L17.7446 14.1007C17.183 13.5391 16.2726 13.5391 15.7119 14.1007L14.8466 14.967C14.6386 15.175 14.3233 15.2449 14.054 15.1261C12.7804 14.5636 11.525 13.7174 10.4037 12.5961Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutlined);
export default __webpack_public_path__ + "static/media/call-outlined.296f4f1d0af59209e21d02caffb8fb30.svg";
export { ForwardRef as ReactComponent };